module.exports = __webpack_public_path__ + "media/images/menu/constellations-97cbdad336da83169c8c42565fc0cdd6.jpg";